// store the information of leaders

export const LEADERS = [
  {
    id: 0,
    name: 'Muzaffar Bek',
    image: '/assets/images/icons8-unsplash2.png',
    designation: 'Chief Executive  Officer',
    abbr: 'CEO',
    featured: false,
    description: "Our CEO, Muzaffar, credits his hardworking Central Asian parents who undertook the arduous journey to the remote areas of Samarkand with the intention of giving their children the best future. His mother's wizardy in the kitchen whipping up the tastiest dishes with whatever is available inexpensively at the supermarket, was his first inspiration to create cakes."
  },
  {
    id: 1,
    name: 'Hasan Hamidov',
    image: '/assets/images/austin-unsplash2.png',
    designation: 'Chief Food Officer',
    abbr: 'CFO',
      featured: false,
    description: 'Our CFO, Hasan, as she is affectionately referred to by her colleagues, comes from a long established family tradition in farming and produce. Her experiences growing up on a farm in the Uzbek outback gave him great appreciation for varieties of food sources. As she puts it in his own words, Everything that runs, wins, and everything that stays, pays!'
  },
  {
    id: 2,
    name: 'Husayin Hamidov',
    image: '/assets/images/austin-unsplash.png',
    designation: 'Chief Taste Officer',
    abbr: 'CTO',
      featured: false,
    description: 'Blessed with the most discerning gustatory sense, Husayin, our CFO, personally ensures that every dish that we serve meets his exacting tastes. Our chefs dread the tongue lashing that ensues if their dish does not meet his exacting standards. He lives by his motto, You click only if you survive my lick.'
  },
  {
    id: 3,
    name: 'Abdul Qadeer',
    image: '/assets/images/chef.png',
    designation: 'Executive Chef', 
    abbr: 'EC',
    featured: true,
    description: 'Award winning three-star Abdul chef with wide International experience having worked closely with whos-who in the culinary world, he specializes in creating mouthwatering Uzbek-Central Asian fusion experiences.'
  }
];